import { parse } from 'query-string';
import { di } from 'react-magnetic-di';
import type { RecordProxy } from 'relay-runtime';

export const setIsViewConfigModifiedRecord = ({
	isViewConfigModified,
	viewRecord,
}: {
	isViewConfigModified: boolean;
	viewRecord: RecordProxy;
}) => {
	di(globalThis);
	const { groupBy, hideDone, jql } = parse(globalThis.location.search);

	viewRecord.setValue(isViewConfigModified, 'isViewConfigModified', {
		settings: {
			groupBy,
			hideDone: hideDone === 'true' || hideDone === 'false' ? hideDone === 'true' : undefined,
			jql,
		},
	});
};
